export const SpanishData = [
    { 
      heading: "Piloto de la herramienta de inspecciones",
      atpSection: {
        introMessage: {
          quote: "Estamos considerando una herramienta de evaluación de vehículos con inteligencia artificial para revolucionar cómo evaluamos los vehículos. Su participación en este piloto es invaluable mientras lideramos el camino en el aprovechamiento de la tecnología para servir mejor a nuestros clientes.",
          author: {
            name: "Antonio Ward",
            designation: "Director General - Vehículos Terminados",
            photo: '/Assets/images/photo.jpg',
          }
        },
        introVideoTitle: "Introducción del Piloto"
      },
      purposeSection: {
        heading: "Objetivo del piloto",
        description: "Ver si puedes usar la app de focalx para realizar inspecciones facilmente.",
        taskHeading: "Tus tareas",
        tasks: [
          "Guarda esta página",
          'Descarga la app "Auto Inspection" (escanea el código QR al fondo de esta página)',
          "Ingresa con las credenciales que te dará tu gerente.",
          "Realiza todas las imágenes del vehículo cuando realices una inspección.",
          "Completa el questionario de VASCOR después de recibir cada reporte."
        ],
        timelineHeading : "Línea de tiempo",
      },
      inspectionSection: {
        heading: "Academia de Inspecciones: ¿Cómo hacer una inspección con la app?",
        downloadManual: "Descargar Manual",
        relatedVideosTitle: "Échale un vistazo a nuestros tutoriales de 30 segundos aquí:",
        relatedVideos: [
          {
            poster: '/Assets/images/user-flow-poster.png',
            video: "app-demo-walkthrough.mp4",
            title: "1. Flujo de usuarios:",
            description: "descripción general rápida de principio a fin del flujo de usuarios.",
            time: "0m24s"
          },
          {
            poster: '/Assets/images/Video-01.png',
            video: "app-demo-walkthrough.mp4",
            title: "2. Descarga e instalación:",
            description: 'Disponible en la App store y Google play. Descarga e instala la app "Auto inspection" para empezar tus inspecciones.',
            time: "0m24s"
          },
          {
            poster: '/Assets/images/Video-03.png',
            video: 'app-demo-walkthrough.mp4',
            title: "3. Crear inspecciones:",
            description: "Escanea la matrícula o el VIN, añade el tipop de vehñiculo y empeiza tu nueva inspección",
            time: "0m16s"
          },
          {
            poster: '/Assets/images/Video-04.png',
            video: "app-demo-walkthrough.mp4",
            title: "4. Inspección guiada por sistema de IA:",
            description: "Captura tu vehículo con la ayuda de nuestro sistema guiado para tener tus daños detectados y documentados en la app.",
            time: "0m26s"
          },
          {
            poster: '/Assets/images/Video-02.png',
            video: "app-demo-walkthrough.mp4",
            title: "5. Revisa las inspecciones:",
            description: "Ten contril sobre tus inspecciones al navegar por tus daños e imagenes de vehículos.",
            time: "0m30s"
          },
          {
            poster: '/Assets/images/Video-07.png',
            video: "app-demo-walkthrough.mp4",
            title: "6. Descarga el reporte PDF:",
            description: "Descarga el reporte completo de daños de tu vehículo en el movil para acceso rápido.",
            time: "0m20s"
          },
          {
            poster: '/Assets/images/Video-05.png',
            video: "app-demo-walkthrough.mp4",
            title: "7. Añade daño manualmente:",
            description: "Añade cualquier daño adicional a través de la funcionalidad de añadir manualmente daño.",
            time: "0m39s"
          },
          {
            poster: '/Assets/images/Video-08.png',
            video: "app-demo-walkthrough.mp4",
            title: "8. Ingresa y revisa tus inspecciones completadas:",
            description: "Recibe un correo con todas las imágenes de tu vehículo y todos los daños detectados. Ingresa con tus credenciales al sistema wev para navegar todas tus inspecciones.",
            time: "0m57s"
          },
          {
            poster: '/Assets/images/Video-09.png',
            video: "app-demo-walkthrough.mp4",
            title: "9.  ¿Cómo enviar enlaces únicos al cliente?",
            description: "una descripción general rápida de cómo enviar a sus clientes un enlace para que puedan realizar una inspección del vehículo.",
            time: "0m57s"
          }
        ]       
      },
      helpSection: {
        heading: "Estamos aquí para ayudarte 24/7",
        chatHeading: "Chatea con nosotros",
        emailHeading: "Escríbenos un email",
        chat: {
          intercom: "Intercom",
          whatsapp: "+502-570-3238",
          weChat: "WeChat",
          emailAddress: "contact@focalx.ai"
        },
        formHeading: "Dejanos un comentario y tu email",       
        form: {
          nameFiled: "Ingresa nombre",
          emailField: "Ingresa email",
          commentField: "Ingresa mensaje",
          buttonText: "Enviar",
        }
      },
      faqSection: {
        heading: "Preguntas comunes",
        accordionItems: [
          {
            accordianTitle: "¿Las imágenes deben ajustarse a las plantillas?",
            accordianContent: ["No, no have falta. Haz tu mejor esfuerzo y cuanto más cerca del auto tomes la foto, mejor. Pero las plantillas están ahí simplemente para orientarte sobre qué imagen debes tomar."]
          },
          {
            accordianTitle: "¿Cuánto tiempo tarda obtener mis resultados?",
            accordianContent: ["Una vez que se hayan cargado todas las imágenes del vehículo, los resultados deberían estar en su bandeja de entrada en no más de 30 minutos. Esto se debe a que este es un piloto y es la primera semana. Cuanto más usas la aplicación, más aprende y más rápido se vuelve."]
          },
          {
            accordianTitle: "¿Qué significan estos k1, k2 .... k5?",
            accordianContent: [
              "K1: Puedes limpiar esto.", 
              "K2: Puedes pulir esto.", 
              "K3: Pequeños daños que no puedes reparar tú mismo.", 
              "K4: Un profesional necesita reparar esto.", 
              "K5: Es posible que sea necesario reemplazar la pieza."]
          },
          {
            accordianTitle: "¿Hay que limpiar el coche antes de inspeccionarlo?",
            accordianContent: ["No necesariamente. El sistema detectará daños incluso si el coche no está limpio. Pero no es magia, por lo que si el ojo humano no puede ver el daño y el daño no se puede ver en la foto, Ai no puede detectarlo."]
          },
          {
            accordianTitle: "¿Necesito tomar todas las imágenes?",
            accordianContent: ["Sí, para que el sistema realice su análisis es necesario tomar y cargar todas las imágenes para garantizar un informe de inspección estandarizado y exhaustivo."]
          },
          {
            accordianTitle: "¿Se compartirá alguna información del cliente?",
            accordianContent: ["No, no lo harán. No se compartirán nombres ni información de clientes en este piloto y ninguno de los datos generados se utilizará para ningún propósito comercial aparte de  VASCOR y usted para evaluar el rendimiento de esta herramienta."]
          },
          {
            accordianTitle: "¿Qué hago si veo una discrepancia o tengo un problema con la aplicación?",
            accordianContent: ["Asegúrese de comunicarse con el soporte, ellos lo guiarán a través de una resolución. Pero no olvides anotarlo también en tu encuesta posterior a la inspección. Cuantos más detalles puedas proporcionar, mejor."]
          }          
        ]
      },
      downloadSection: {
        content: {
          downloadNow: "Descarga ahora",
          autoInspection: "Auto Inspection",
          description: "Encuéntralo en la App Store o en Google Play al buscarlo o al escanear el código QR.",    
        }
      },
      footer: "© FocalX ApS. Todos los derechos reservados.",
      lockScreen: {
        title: "Ingrese PIN para acceder",
        buttonText: "Verificar",    
      },
    }
];